'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import ResultItem from 'DesignFinderUI/components/results/ResultItem';

const i18nKey = key => `DesignFinderUI.results.RevisionResultItem.results.${key}`;

class RevisionResultItem extends PureComponent {
  constructor(props) {
    super(props);
    this.handleNavigateToRevision = this.handleNavigateToRevision.bind(this);
    this.handleRevertClick = this.handleRevertClick.bind(this);
  }

  handleNavigateToRevision() {
    this.props.onNavigateToRevision(this.props.revisionId);
  }

  handleRevertClick() {
    this.props.onRevertClick(this.props.revisionId);
  }

  getFormattedDateText(updated) {
    return I18n.moment.utc(updated).portalTz().format('l LT');
  }

  getAuthorText(user) {
    if (!user) {
      return null;
    } // Fullname can be an empty string


    if (user.fullName && user.fullName.trim().length) {
      return user.fullName;
    }

    return user.username || user.email || text(i18nKey('unknownUser'));
  }

  renderRevisionNumber(__revisionNumber) {
    const revisionNumber = __revisionNumber < 10 ? `0${__revisionNumber}` : __revisionNumber;
    return /*#__PURE__*/_jsxs("b", {
      children: [revisionNumber, "."]
    });
  }

  renderTimestamp(updated, isCurrent, revisionRoute) {
    let formattedTimestamp = this.getFormattedDateText(updated);

    if (isCurrent) {
      formattedTimestamp = /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('timestamp.current'),
        options: {
          timestamp: formattedTimestamp
        }
      });
    }

    return /*#__PURE__*/_jsx(UIRouterLink, {
      to: revisionRoute,
      use: "unstyled",
      children: formattedTimestamp
    });
  }

  renderAuthor(user) {
    const authorText = this.getAuthorText(user);

    if (!authorText) {
      return null;
    }

    return /*#__PURE__*/_jsx(UITruncateString, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('author'),
        options: {
          author: authorText
        }
      })
    });
  }

  render() {
    const {
      active,
      revertDisabled,
      revertButtonTooltip,
      isCurrent,
      revisionNumber,
      revisionRoute,
      updated,
      user
    } = this.props;
    const renderedRevisionNumber = this.renderRevisionNumber(revisionNumber);
    const renderedTimestamp = this.renderTimestamp(updated, isCurrent, revisionRoute);
    const renderedAuthor = this.renderAuthor(user);
    let itemProps = {
      active,
      className: 'file-revisions__results__item',
      help: renderedAuthor,
      icon: renderedRevisionNumber,
      onItemClick: this.handleNavigateToRevision,
      title: renderedTimestamp
    };

    if (!isCurrent) {
      itemProps = Object.assign({}, itemProps, {
        buttonText: text(i18nKey('button.text')),
        onButtonClick: this.handleRevertClick,
        buttonDisabled: revertDisabled,
        buttonTooltip: revertButtonTooltip
      });
    }

    return /*#__PURE__*/_jsx(ResultItem, Object.assign({}, itemProps));
  }

}
/**
 * Statics
 */


RevisionResultItem.propTypes = {
  active: PropTypes.bool,
  isCurrent: PropTypes.bool,
  onNavigateToRevision: PropTypes.func.isRequired,
  onRevertClick: PropTypes.func.isRequired,
  revertDisabled: PropTypes.bool,
  revertButtonTooltip: PropTypes.node,
  revisionId: PropTypes.number.isRequired,
  revisionNumber: PropTypes.number.isRequired,
  revisionRoute: PropTypes.string.isRequired,
  updated: PropTypes.number.isRequired,
  user: PropTypes.shape({
    fullName: PropTypes.string,
    username: PropTypes.string,
    email: PropTypes.string,
    id: PropTypes.number
  })
};
RevisionResultItem.defaultProps = {
  active: false,
  revertDisabled: true,
  isCurrent: false,
  user: null
};
/**
 * Export
 */

export default RevisionResultItem;